<template>
  <span>
    <el-tooltip class="item" effect="dark" content="Import day of services" placement="top-start">
      <el-button
          id="btn-import-dos"
          type="success"
          plain
          @click="dialogVisible = true"
          size="mini"
      >
        Import day of services
      </el-button>
    </el-tooltip>

    <el-dialog
        v-on:open="handleOpen"
        title="Upload day of services CSV"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="450px"
        append-to-body
        class="dialog-with-cols"
    >
      <div class="upload-container">
        <div class="sample-link-container">
          <i class="el-icon-document"></i>
          <span>Need help with the format? </span>
          <a :href="`${publicPath}sample-day-of-services.csv`" download="sample-day-of-services.csv" class="sample-link">
            Download sample CSV
          </a>
        </div>

        <el-upload
            class="upload-demo"
            drag
            action=""
            :http-request="uploadFile"
            :limit="1"
            accept=".csv"
            :on-exceed="handleExceed"
            ref="uploadRef"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Drop CSV file here or <em>click to upload</em></div>
          <div class="el-upload__tip" slot="tip">Only CSV files are allowed.</div>
        </el-upload>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
            type="primary"
            @click="dialogVisible = false"
            size="mini"
        >
          Close
        </el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';
import accountService from '@/api/accountService';

export default {
  name: 'ImportDayOfServices',
  data() {
    return {
      dialogVisible: false,
      // Create a reactive property for the base URL
      publicPath: process.env.BASE_URL || '/'
    };
  },
  methods: {
    handleOpen() {
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },
    handleExceed() {
      this.$message.warning('You can only upload one file at a time.');
    },
    async uploadFile(options) {
      const { file, onSuccess, onError } = options;
      const loading = this.$loading(constants.LOADING?.DEFAULT_CONFIG || { lock: true, text: 'Uploading...' });

      try {
        const formData = new FormData();
        formData.append('file', file);

        // Placeholder for real API call
        const response = await accountService.uploadDayOfServices(formData);

        // await new Promise(resolve => setTimeout(resolve, 1000));
        // const response = { message: 'Day of services imported successfully.' };

        this.$message.success(response.message);
        onSuccess(response);
      } catch (error) {
        this.$message.error(error.message || 'An error occurred while uploading the file.');
        onError(error);
      } finally {
        loading.close();
        this.dialogVisible = false;
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#btn-import-dos {
  margin-right: 10px;
}

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}

.sample-link-container {
  margin-bottom: 25px;
  font-size: 14px;
  color: #606266;
  background-color: #f4f4f5;
  padding: 10px 15px;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;

  .sample-link {
    color: #409EFF;
    text-decoration: none;
    font-weight: bold;
    margin-left: 5px;

    &:hover {
      text-decoration: underline;
    }
  }
}

.upload-demo {
  width: 100%;
  text-align: center;

  ::v-deep .el-upload {
    width: 100%;
  }
  ::v-deep .el-upload-dragger {
    width: 100%;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
